import React from "react";
import { Grid, Divider, useMantineTheme } from '@mantine/core';

const LabelContentInline = ({
    stateColLabel = 4,
    stateLabel = '',
    stateContent = '',
    stateContentIsPreLine = false,
    stateDivider = true,
    stateDividerMT = '.5rem',
    stateDividerMB = '.5rem',
}) => {

    const theme = useMantineTheme();

    return (
        <React.Fragment>
            <Grid>
                {Number(stateColLabel) > 0 &&
                    <Grid.Col
                        span={Number(stateColLabel)}
                        sx={{
                            color: theme.colorScheme === 'light' ? theme.colors.gray[6] : theme.colors.gray[6]
                        }}
                    >
                        {stateLabel}
                    </Grid.Col>
                }

                {12 - Number(stateColLabel) > 0 &&
                    <Grid.Col
                        span={12 - Number(stateColLabel)}
                        sx={{
                            whiteSpace: stateContentIsPreLine ? 'pre-line' : 'normal'
                        }}
                    >
                        {stateContent}
                    </Grid.Col>
                }
            </Grid>

            {stateDivider &&
                <Divider
                    mt={stateDividerMT}
                    mb={stateDividerMB}
                    sx={{
                        borderTopWidth: '1px',
                        borderStyle: 'dashed',
                        borderTopColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[5]
                    }}
                />
            }
        </React.Fragment>
    )
}

export default LabelContentInline;